import React, {useMemo} from "react";
import {AutoVisitStatusV2} from "~/apps/packages/auto-visits/queries";
import {StatusBadge, StatusBadgeProps} from "~/apps/core/ui/StatusBadge";
import {getAutoVisitStatusColor} from "~/apps/packages/auto-visits/utils";
import {getOfferStatusColor} from "~/apps/packages/auto-shipment-orders/utils";


export const OrdersListStatusBadge = (props) => {
    const {children, ...otherProps} = props;
    const status = useMemo(() => children, [children]);
    const badgeColor = useMemo(() => getOfferStatusColor(status), [status]);

    return (
        <StatusBadge {...otherProps} badgeColor={badgeColor} outlined={false}>
            {status}
        </StatusBadge>
    )
}
